import axios from "axios"
import { getToken } from "../helpers/functions";

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL
axios.defaults.headers.common["Authorization"] = getToken()
axios.defaults.headers.common["Content-Type"] = "application/json"
axios.defaults.headers.common['development'] = 'true'

export const postWithoutAuth = (url, data) =>
    axios.post(url, data, {
        transformRequest: [
            (body, headers) => {
                delete headers.Authorization;
                if (headers.common) {
                    delete headers.common.Authorization;
                }
                headers["Content-Type"] = "application/json";
                return JSON.stringify(body);
            },
        ],
    });

export default axios
